import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Language } from '../../../models/language.model';
import { LanguageService } from './../../../services/language/language.service';

@Component({
  selector: 'kv-language-form',
  templateUrl: 'languageForm.html',
  styles: ['label.required:after {top: 0}']
})

export class LanguageFormComponent implements OnInit{
  @Output() languageAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() languageUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxLanguage: Language;
  addEditForm: FormGroup;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private languageService: LanguageService
  ) {}

  ngOnInit() {

    this.languageService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm = this.fb.group({
      'language': new FormControl(this.dialogBoxLanguage.language, Validators.maxLength(100)),
      'iso_code': new FormControl(this.dialogBoxLanguage.iso_code, Validators.maxLength(100)),
      'nls_code': new FormControl(this.dialogBoxLanguage.nls_code, Validators.maxLength(100)),
    });
  }

  saveOrUpdate(): void {
    console.log('request to insert or update language');
    console.log(this.dialogBoxLanguage);

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = this.addEditForm.value;
    newData.id = this.dialogBoxLanguage.id;
    if (newData.id == null) {
      this.languageAdded.emit(newData);
    } else {
      this.languageUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/language/languageForm.component.ts